import React from "react";
import { SocialLink } from "../../../models/coms.model";
import "./ComsFooter.css";
import { usePageNavigator } from "../../../hooks/usePageNavigator";
interface FooterProps {
	onPrivacyClick: () => void;
	socialLinks: SocialLink[];
}

export const ComsFooter: React.FC<FooterProps> = ({ onPrivacyClick, socialLinks }) => {
	const navigate = usePageNavigator();
	return (
		<div className="footer-layer">
			<div className="social-container">
				{socialLinks.map(({ href, icon, label }) => (
					<a
						key={label}
						href={href}
						target="_blank"
						rel="noopener noreferrer"
						aria-label={label}
					>
						<img
							src={icon}
							alt={label}
							className="social-icon"
						/>
					</a>
				))}
			</div>
			<footer className="bonk-footer">
				<div className="footer-section">
					<div>
						<h4
							className="pointer"
							onClick={() => navigate(0)}
						>
							Home
						</h4>
						<h4
							className="pointer"
							onClick={() => navigate(1)}
						>
							Key Projects
						</h4>
						<h4
							className="pointer"
							onClick={() => navigate(2)}
						>
							About
						</h4>
						<h4
							className="pointer"
							onClick={() => navigate(4)}
						>
							Integrations
						</h4>
						<h4
							className="pointer"
							onClick={() => navigate(6)}
						>
							Subscribe
						</h4>
					</div>
					<div>
						<h4>CONTACT</h4>
						<ul>
							<li>
								<a
									href="https://www.bonkcoindao.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Partnerships
								</a>
							</li>
							<li>
								<a
									href="https://lu.ma/user/BONK"
									target="_blank"
									rel="noopener noreferrer"
								>
									Events
								</a>
							</li>
						</ul>
					</div>
					<div>
						<h4>KEY PROJECTS</h4>
						<ul>
							<li>
								<a
									href="https://bonkrewards.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									BONKrewards
								</a>
							</li>
							<li>
								<a
									href="https://bonkmark.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									BONKmark
								</a>
							</li>
							<li>
								<a
									href="https://bonkscooper.app/"
									target="_blank"
									rel="noopener noreferrer"
								>
									BONKscooper
								</a>
							</li>
							<li>
								<a
									href="https://bonk.live/"
									target="_blank"
									rel="noopener noreferrer"
								>
									BONKlive
								</a>
							</li>
							<li>
								<a
									href="https://bonkbets.io/"
									target="_blank"
									rel="noopener noreferrer"
								>
									BONKbets
								</a>
							</li>
						</ul>
					</div>
					<div>
						<h4>BONK FAMILY</h4>
						<ul>
							<li>
								<a
									href="https://moonwalk.fit/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Moonwalk Fitness
								</a>
							</li>
							<li>
								<a
									href="https://exchange.art/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Exchange Art
								</a>
							</li>
							<li>
								<a
									href="https://exchange.art/bonk-galleries/nfts"
									target="_blank"
									rel="noopener noreferrer"
								>
									BONK Art Masters
								</a>
							</li>
							<li>
								<a
									href="https://letsbonk.fun"
									target="_blank"
									rel="noopener noreferrer"
								>
									Let's BONK
								</a>
							</li>
							<li>
								<a
									href="https://www.bonkforpaws.org/"
									target="_blank"
									rel="noopener noreferrer"
								>
									BONK For Paws
								</a>
							</li>
						</ul>
					</div>
					<div>
						<ul>
							<li>
								<a
									href="https://baobaoinu.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									BaoBao Merch
								</a>
							</li>
							<li>
								<a
									href="https://bonk.sfo3.cdn.digitaloceanspaces.com/docs/BONK-Paper.pdf"
									target="_blank"
									rel="noopener noreferrer"
								>
									White Paper
								</a>
							</li>
							<li>
								<a
									href="https://drive.google.com/drive/folders/13rUp99HkBZzjXAJK_Ma4yZMBaxz5Jw6W?usp=drive_link"
									target="_blank"
									rel="noopener noreferrer"
								>
									Logos
								</a>
							</li>
							<li>
								<button
									className="privacy-link"
									onClick={onPrivacyClick}
								>
									Privacy Policy
								</button>
							</li>
						</ul>
					</div>
				</div>
				<div className="footer-copyright">
					<p className="footer-text">© 2025 BONK. All rights reserved.</p>
				</div>
			</footer>
		</div>
	);
};
